import Vue from 'vue';
import Vuex from 'vuex';
import getNested from 'lodash-es/get';

Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {};
  },
  actions: {
    async getVesselsInArea(store, parameters) {
      // expected parameters example:
      // destinationRegion: []
      // dwt: [0, 450000]
      // includeUnknownDestinationRegion: true
      // ladenPercent: [0, 1]
      // lowerLeft: [-55.81054687500001, 20.632784250388028]
      // upperRight: [53.43750000000001, 65.25670649344259]
      // speed: [0, 25]

      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/vessels/inarea',
        data: parameters,
      });

      if(response.error) {
        console.log('api error', response);
        return {error: true};
      }
      return response.data || {};
    },

    async getVesselLiveDetails(store, imo) {
      // expected parameter:
      // GET: imo=<imo_number>

      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/vessels/cbt',
        data: {
          imo,
        },
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return getNested(response, 'data.vessels.0', {});
    },

    async getVesselsLiveDetails(store, parameters) {
      // expected parameter:
      // 	"imos": [<imo_number>, ]

      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/vessels/imo',
        data: parameters,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response.data.vessels || [];
    },

    async getVesselPositions(store, data) {
      // expected url parameter:
      // 	imo=1234567
      // start_datetime=2005-01-01T00:00:00
      // end_datetime=2020-12-31T23:59:59

      let response = await store.dispatch('apiRequest', {
        method: 'get',
        apiUrl: '/vessels/positions/historical',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data.vesselPositions', []);
    },

    async getRawVesselEvents(store, data) {
      // expected url parameter:
      // 	imo=1234567
      // start_datetime=2005-01-01T00:00:00
      // end_datetime=2020-12-31T23:59:59

      let response = await store.dispatch('apiRequest', {
        method: 'get',
        apiUrl: '/vessels/rawevents',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data.rawEvents', []);
    },

    async getHistoricalVoyages(store, data) {
      // expected POST parameters:
      //
      // segment
      // subSegment
      // commodityId
      // loadBerthIds
      // loadPortIds
      // dischargeBerthIds
      // dischargePortIds
      // imos
      // limit
      // page

      let response = await store.dispatch('apiRequest', {
        method: 'post',
        apiUrl: '/vessels/historicalvoyages',
        data: data,
      });

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return getNested(response, 'data', {});
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'api/apiRequest',
        {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL_V2},
        {root: true},
      );
    },
  },
};
